import React, { useState } from "react";
import { useQueryClient } from "react-query";
import { getSupaClient } from "../../lib/supabase";

function useRefreshChannelsAndRoles() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const supabase = getSupaClient();
  const queryClient = useQueryClient();

  const refresh = async () => {
    setIsLoading(true);
    const session = await supabase.auth.session();
    const guild = localStorage.getItem("guild-id");
    const path = `/guilds/${guild}/refresh`;

    try {
      const response = await fetch(
        `${process.env["REACT_APP_API_URL"]}${path}`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${session?.access_token}` },
        }
      );

      if (response.ok) {
        if (guild) {
          queryClient.invalidateQueries("guildChannels");
          queryClient.invalidateQueries("guildRoles");
          setSuccess(true);
        }
      } else {
        setError(true);
        console.error("error in refresh button", response);
      }
    } catch (error) {
      console.error("error in refresh button", error);
      setError(true);
    }
  };

  const resetRefreshState = () => {
    setSuccess(false);
    setIsLoading(false);
    setError(false);
  };

  return {
    isRefreshLoading: isLoading,
    refreshError: error,
    refreshSuccess: success,
    refresh,
    resetRefreshState,
  };
}

export default useRefreshChannelsAndRoles;
